export function getToken() {
    if (localStorage.getItem('speed_tech')) {
        const speed_tech = JSON.parse(localStorage.getItem('speed_tech'));
        if (speed_tech.token) {
            return speed_tech.token;
        }
    }
    return null;
}
